(function() {
    "use strict";

    angular.module("app.customer").factory("CustomerAddressService", CustomerAddressService);

    CustomerAddressService.$inject = ["$http", "$q", "GeneralService"];

    function CustomerAddressService($http, $q, GeneralService) {
        var service = {
            addCustomerAddress: addCustomerAddress,
            addCustomerAddressWithUser: addCustomerAddressWithUser,
            editCustomerAddress: editCustomerAddress,
            deleteCustomerAddress: deleteCustomerAddress,
            getCustomerAddresses: getCustomerAddresses,
            getCustomerAddress: getCustomerAddress,
            getCustomerAddressFields: getCustomerAddressFields
        };

        var serviceBase = "/";

        var customerAddressFields = [
            {
                key: "Name",
                type: "horizontalInput",
                templateOptions: {
                    required: true,
                    label: "Adres Adı"
                }
            },
            {
                key: "Phone1",
                type: "horizontalPhone",
                templateOptions: {
                    label: "Telefon"
                }
            },

            {
                key: "CountryId",
                type: "horizontalSelect",
                templateOptions: {
                    label: "Ülke",
                    required: true,
                    options: [{ name: "Seçiniz..." }]
                },

                //expressionProperties: {
                //    'templateOptions.options': function ($viewValue, $modelValue, scope) {
                //        var empty = [{ Name: 'Seçiniz...' }];
                //        return GeneralService.getCountry();
                //    }
                //},
                controller: [
                    "$scope",
                    function($scope) {
                        GeneralService.getCountry().then(function(data) {
                            $scope.to.options = data;
                        });
                    }
                ]
            },
            {
                key: "StateProvinceId",
                type: "horizontalSelect",
                templateOptions: {
                    label: "İl",
                    required: true,
                    options: [{ Name: "Önce Ülke Seçiniz..." }]
                },
                controller: [
                    "$scope",
                    function($scope) {
                        $scope.$watch("model.CountryId", function(newValue, oldValue) {
                            if (newValue) {
                                GeneralService.getStateProvince($scope.model.CountryId).then(function(data) {
                                    $scope.to.options = data;
                                });
                            } else {
                                $scope.to.options = [{ Name: "Önce Ülke Seçiniz..." }];
                            }
                        });
                    }
                ]
            },
            {
                key: "DistrictId",
                type: "horizontalSelect",
                templateOptions: {
                    label: "İlçe",
                    required: true,
                    options: [{ Name: "Önce İl Seçiniz..." }]
                },
                controller: [
                    "$scope",
                    function($scope) {
                        $scope.$watch("model.StateProvinceId", function(newValue, oldValue) {
                            if (newValue) {
                                GeneralService.getDistrict($scope.model.StateProvinceId).then(function(data) {
                                    $scope.to.options = data;
                                });
                            } else {
                                $scope.to.options = [{ Name: "Önce İl Seçiniz..." }];
                            }
                        });
                    }
                ]
            },
            {
                key: "CityId",
                type: "horizontalSelect",
                templateOptions: {
                    label: "Mahalle",
                    options: [{ Name: "Önce İlçe Seçiniz..." }]
                },

                //expressionProperties: {
                //    'templateOptions.options': function ($viewValue, $modelValue, scope) {
                //        if (scope.model.DistrictId) {
                //            var empty = [{ Name: 'Seçiniz...' }];
                //            return GeneralService.getCity(scope.model.DistrictId);
                //        } else {
                //            return [{ Name: 'Önce İlçe Seçiniz...' }];
                //        }
                //    }
                //},
                controller: [
                    "$scope",
                    function($scope) {
                        $scope.$watch("model.DistrictId", function(newValue, oldValue) {
                            if (newValue) {
                                GeneralService.getCity($scope.model.DistrictId).then(function(data) {
                                    $scope.to.options = data;
                                });
                            } else {
                                $scope.to.options = [{ Name: "Önce İl Seçiniz..." }];
                            }
                        });
                    }
                ]
            },
            {
                key: "Description",
                type: "horizontalTextarea",
                templateOptions: {
                    type: "text",
                    label: "Adres"
                }
            }
        ];

        var customerAddressList = [];

        return service;

        ///////////////////////////////////////////////////

        function addCustomerAddress(address) {
            var deferred = $q.defer();

            $http
                .post(serviceBase + "api/UserAddress", address)
                .then(addCustomerAddressComplete)
                .catch(addCustomerAddressFailed);

            function addCustomerAddressComplete(response) {
                customerAddressList.push(response.data);
                deferred.resolve(response);
            }

            function addCustomerAddressFailed(error) {
                deferred.reject(error);
            }
            return deferred.promise;
        }

        function addCustomerAddressWithUser(address) {
            var deferred = $q.defer();

            $http
                .post(serviceBase + "api/UserAddress/WithUser", address)
                .then(addComplete)
                .catch(addFailed);

            function addComplete(response) {
                customerAddressList.push(response.data);
                deferred.resolve(response.data);
            }

            function addFailed(error) {
                deferred.reject(error);
            }
            return deferred.promise;
        }

        function editCustomerAddress(address) {
            var deferred = $q.defer();
            $http
                .put(serviceBase + "api/UserAddress/" + address.Id, address)
                .then(editCustomerAddressComplete)
                .catch(editCustomerAddressFailed);

            function editCustomerAddressComplete(response) {
                var address = customerAddressList.find(function(data) {
                    return data.Id === response.data.Id;
                });
                var index = customerAddressList.indexOf(address);
                customerAddressList[index] = response.data;
                deferred.resolve(response);
            }

            function editCustomerAddressFailed(error) {
                deferred.reject(error);
            }
            return deferred.promise;
        }

        function deleteCustomerAddress(address) {
            var deferred = $q.defer();

            $http
                .delete(serviceBase + "api/UserAddress/" + address.Id, address)
                .then(deleteCustomerAddressComplete)
                .catch(deleteCustomerAddressFailed);

            function deleteCustomerAddressComplete(response) {
                var index = customerAddressList.indexOf(address);
                customerAddressList.splice(index, 1);
                deferred.resolve(response);
            }

            function deleteCustomerAddressFailed(error) {
                deferred.reject(error);
            }
            return deferred.promise;
        }

        function getCustomerAddresses() {
            var deferred = $q.defer();
            $http
                .get(serviceBase + "api/UserAddress")
                .then(getCustomerAddressesComplete)
                .catch(getCustomerAddressesFailed);

            function getCustomerAddressesComplete(response) {
                customerAddressList = response.data;
                deferred.resolve(customerAddressList);
            }

            function getCustomerAddressesFailed(error) {
                deferred.reject(error);
            }

            return deferred.promise;
        }

        function getCustomerAddress(addressId) {
            var deferred = $q.defer();
            $http
                .get(serviceBase + "api/UserAddress/" + addressId)
                .then(getCustomerAddressesComplete)
                .catch(getCustomerAddressesFailed);

            function getCustomerAddressesComplete(response) {
                var address = customerAddressList.find(function(data) {
                    return data.Id === response.data.Id;
                });
                if (address) {
                    var index = customerAddressList.indexOf(address);
                    customerAddressList[index] = response.data;
                } else {
                    customerAddressList.push(response.data);
                }
                deferred.resolve(response);
            }

            function getCustomerAddressesFailed(error) {
                deferred.reject(error);
            }
            return deferred.promise;
        }

        function getCustomerAddressFields() {
            return customerAddressFields;
        }
    }
})();
